export const SOURCE = 'mac/FETCH_SOURCE';
export const PO_NUMBER_UPDATE = 'mac/PO_NUMBER_UPDATE';
export const CART_FOR_ORDER = 'mac/FETCH_CART_FOR_ORDER';
